import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Coin = (props: SvgProps) => (
  <Svg width={25} height={28} viewBox="0 0 25 28" fill="none" {...props}>
    <path
      d="M9.01107 2.41257C8.89982 2.43976 8.3091 2.59132 7.60441 2.94081C6.97254 3.25472 6.50761 3.60878 6.33255 3.74171C6.11884 3.90412 5.68903 4.25662 5.20893 4.78406C4.72527 5.31698 4.41478 5.78592 4.24751 6.0389C3.93855 6.50397 3.31551 7.55454 2.85006 9.09626C2.64304 9.77954 2.52028 10.3976 2.45362 10.7958C2.32772 11.5493 2.28098 12.1914 2.2643 12.5967C2.24458 13.0712 2.18524 14.516 2.56743 16.3975C2.68258 16.9614 2.88221 17.706 3.06563 18.2519C3.33726 19.0627 3.61388 19.6467 3.76321 19.96C4.08916 20.6482 4.71686 21.7661 5.66336 22.8435C6.70529 24.0305 7.64014 24.6081 8.08792 24.8852C8.29765 25.0155 8.59085 25.1659 8.81346 25.2733C8.99799 25.3629 9.25292 25.4612 9.44118 25.5405C9.66591 25.6357 9.97753 25.7337 10.2147 25.7873C10.407 25.8303 10.6629 25.8941 10.8574 25.9248C11.0837 25.9606 11.3866 25.9955 11.6156 26.0106C12.0041 26.0368 12.5241 25.9971 12.9124 25.9666C8.34192 26.5529 3.84312 22.4658 2.60725 16.3902C1.29243 9.93191 4.16316 3.67345 9.01898 2.41089C9.30676 2.33554 9.59409 2.28038 9.88187 2.24402C9.61815 2.28235 9.26974 2.3505 9.00994 2.41281L9.01107 2.41257Z"
      fill="url(#paint0_linear_11287_85115)"
    />
    <path
      d="M15.4193 25.1986C10.7204 26.4207 5.88114 22.3446 4.60964 16.0958C3.3379 9.84575 6.11671 3.7888 10.8145 2.56692C15.5123 1.34504 20.3527 5.4209 21.6242 11.6698C22.896 17.9198 20.116 23.977 15.4193 25.1986Z"
      fill="url(#paint1_linear_11287_85115)"
    />
    <path
      d="M15.0406 24.8915C13.2955 25.2624 11.4991 24.8856 9.84545 23.8014C7.44463 22.2273 5.67385 19.3908 4.98761 16.0177C3.75783 9.97622 6.41623 4.10911 10.9113 2.93978C11.0053 2.91507 11.0987 2.89286 11.1925 2.8729C12.9376 2.50198 14.734 2.87875 16.3877 3.96296C18.7896 5.53684 20.5604 8.37334 21.2453 11.7455C22.4753 17.7882 19.8169 23.6553 15.3205 24.8237C15.2265 24.8484 15.1331 24.8706 15.0392 24.8906L15.0406 24.8915Z"
      fill="url(#paint2_linear_11287_85115)"
    />
    <path
      d="M21.7924 11.6162C21.7849 11.5812 21.6285 10.7507 21.293 9.75613C20.9535 8.74828 20.5824 8.02009 20.5787 8.01379C20.457 7.78086 20.3009 7.469 20.1699 7.24163C20.033 7.00367 19.8484 6.68603 19.6886 6.46241C19.404 6.06324 19.0075 5.5437 18.6957 5.16685C18.5317 4.96776 18.2919 4.71858 18.1021 4.5427C17.9108 4.36592 17.6616 4.1223 17.4549 3.96181C17.1112 3.69575 16.6348 3.36215 16.2698 3.12424C16.2643 3.12068 15.6617 2.74894 14.9166 2.46893C14.0765 2.15356 13.4122 2.07025 13.3842 2.06674C12.9995 2.01971 12.4827 1.99604 12.0951 1.99099C11.8996 1.98882 11.6395 2.02756 11.4456 2.04397C11.158 2.08145 10.8695 2.13686 10.5827 2.21084C5.7266 3.47227 2.85587 9.73073 4.16957 16.1892C5.40543 22.2649 9.90423 26.3519 14.4754 25.7631C14.7391 25.7248 15.0858 25.6487 15.3473 25.5943C15.428 25.5736 15.4597 25.4003 15.4192 25.1986C10.7203 26.4207 5.88101 22.3446 4.60951 16.0957C3.33777 9.84572 6.11658 3.78877 10.8144 2.56689C15.5122 1.34501 20.3526 5.42086 21.6241 11.6697C22.8958 17.9197 20.1159 23.9769 15.4192 25.1986C15.4597 25.4003 15.428 25.5736 15.3473 25.5943C15.591 25.5284 15.912 25.4259 16.147 25.3358C16.3752 25.2471 16.6761 25.1169 16.8894 24.9971C17.2419 24.7981 17.6969 24.5029 18.0261 24.2663C18.2271 24.122 18.4711 23.8964 18.6544 23.7299C19.0851 23.337 19.5831 22.7218 19.6819 22.5803C19.8235 22.3789 20.0256 22.1173 20.151 21.9063C20.3904 21.5033 20.7024 20.9584 20.8978 20.5317C21.2868 19.6868 21.5064 18.9182 21.5086 18.9118C21.6432 18.4105 21.7999 17.7356 21.9022 17.227C21.9564 16.9591 21.9988 16.5967 22.0259 16.3239C22.053 16.0511 22.0817 15.6858 22.0932 15.4116C22.1048 15.1326 22.1024 14.7597 22.1056 14.4801C22.1093 14.197 22.075 13.819 22.061 13.536C22.0279 12.8802 21.8494 11.9291 21.7913 11.6165L21.7924 11.6162Z"
      fill="url(#paint3_linear_11287_85115)"
    />
    <path
      d="M9.88273 2.24384L11.4452 2.04288C11.1577 2.08037 10.8692 2.13577 10.5824 2.20975C5.72653 3.47231 2.8558 9.73077 4.1695 16.1893C5.40536 22.2649 9.90416 26.352 14.4753 25.7632L12.9128 25.9641C8.34165 26.5529 3.84285 22.4659 2.60699 16.3902C1.29216 9.93197 4.16289 3.67351 9.01871 2.41095C9.30649 2.3356 9.59382 2.28043 9.8816 2.24408L9.88273 2.24384Z"
      fill="url(#paint4_linear_11287_85115)"
    />
    <path
      style={{ mixBlendMode: "screen" }}
      d="M10.0343 23.7613C7.6335 22.1872 5.86272 19.3507 5.17648 15.9776C3.9467 9.93607 6.60397 4.0692 11.1001 2.89964C11.1607 2.8844 11.2204 2.87053 11.2801 2.85665C11.2507 2.8629 11.222 2.86665 11.1925 2.8729C11.0987 2.89286 11.0053 2.91507 10.9113 2.93978C6.41623 4.10911 3.75783 9.97622 4.98785 16.0188C5.67409 19.3919 7.44487 22.2284 9.84569 23.8025C11.4993 24.8868 13.2958 25.2635 15.0408 24.8926C15.0747 24.8854 15.1082 24.8759 15.1421 24.8687C13.4248 25.2089 11.6605 24.8277 10.0346 23.7624L10.0343 23.7613Z"
      fill="url(#paint5_radial_11287_85115)"
    />
    <path
      d="M15.0148 24.6582C13.315 25.0195 11.5682 24.6534 9.96162 23.6017C7.65042 22.0878 5.94833 19.3631 5.29004 16.127C4.10911 10.3209 6.68177 4.67885 11.0267 3.54852C12.8164 3.08184 14.6615 3.43173 16.3535 4.54086C18.665 6.05599 20.3668 8.77953 21.0251 12.0156C22.2072 17.8214 19.6334 23.4638 15.2885 24.5941C15.1978 24.6181 15.1053 24.6389 15.0137 24.6584L15.0148 24.6582ZM11.3803 3.86093C11.2944 3.8792 11.2089 3.89973 11.1237 3.92139C6.97475 5.00061 4.52712 10.4412 5.66826 16.049C6.30629 19.1842 7.9479 21.8189 10.1729 23.278C11.7729 24.3263 13.5089 24.658 15.1912 24.2201C19.3402 23.1409 21.7878 17.7002 20.6467 12.0925C20.0086 8.95729 18.367 6.32256 16.1408 4.86376C14.6221 3.86905 12.9761 3.52174 11.3792 3.86117L11.3803 3.86093Z"
      fill="url(#paint6_linear_11287_85115)"
    />
    <path
      d="M14.9743 24.4693C13.2745 24.8306 11.5276 24.4646 9.9211 23.4129C7.6099 21.8989 5.9078 19.1742 5.24951 15.9382C4.06858 10.1321 6.64124 4.49001 10.9862 3.35968C12.7759 2.893 14.621 3.24289 16.313 4.35202C18.6244 5.86715 20.3263 8.59068 20.9846 11.8267C22.1666 17.6326 19.5929 23.2749 15.2479 24.4052C15.1573 24.4292 15.0648 24.4501 14.9732 24.4696L14.9743 24.4693ZM11.34 3.67322C11.2541 3.69149 11.1686 3.71202 11.0834 3.73368C6.93446 4.8129 4.48683 10.2535 5.62797 15.8613C6.266 18.9965 7.90761 21.6312 10.1327 23.0902C11.7326 24.1386 13.4686 24.4703 15.151 24.0324C19.2999 22.9532 21.7475 17.5125 20.6064 11.9048C19.9683 8.76957 18.3267 6.13485 16.1005 4.67605C14.5818 3.68134 12.9358 3.33403 11.3389 3.67346L11.34 3.67322Z"
      fill="url(#paint7_linear_11287_85115)"
    />
    <path
      d="M15.0148 24.6582C13.315 25.0195 11.5682 24.6534 9.96162 23.6017C7.65042 22.0878 5.94833 19.3631 5.29004 16.127C4.10911 10.3209 6.68177 4.67885 11.0267 3.54852C12.8164 3.08184 14.6615 3.43173 16.3535 4.54086C18.665 6.05599 20.3668 8.77953 21.0251 12.0156C22.2072 17.8214 19.6334 23.4638 15.2885 24.5941C15.1978 24.6181 15.1053 24.6389 15.0137 24.6584L15.0148 24.6582ZM11.3803 3.86093C11.2944 3.8792 11.2089 3.89973 11.1237 3.92139C6.97475 5.00061 4.52712 10.4412 5.66826 16.049C6.30629 19.1842 7.9479 21.8189 10.1729 23.278C11.7729 24.3263 13.5089 24.658 15.1912 24.2201C19.3402 23.1409 21.7878 17.7002 20.6467 12.0925C20.0086 8.95729 18.367 6.32256 16.1408 4.86376C14.6221 3.86905 12.9761 3.52174 11.3792 3.86117L11.3803 3.86093Z"
      fill="url(#paint8_linear_11287_85115)"
    />
    <path
      d="M14.9743 24.4693C13.2745 24.8306 11.5276 24.4646 9.9211 23.4129C7.6099 21.8989 5.9078 19.1742 5.24951 15.9382C4.06858 10.1321 6.64124 4.49001 10.9862 3.35968C12.7759 2.893 14.621 3.24289 16.313 4.35202C18.6244 5.86715 20.3263 8.59068 20.9846 11.8267C22.1666 17.6326 19.5929 23.2749 15.2479 24.4052C15.1573 24.4292 15.0648 24.4501 14.9732 24.4696L14.9743 24.4693ZM11.34 3.67322C11.2541 3.69149 11.1686 3.71202 11.0834 3.73368C6.93446 4.8129 4.48683 10.2535 5.62797 15.8613C6.266 18.9965 7.90761 21.6312 10.1327 23.0902C11.7326 24.1386 13.4686 24.4703 15.151 24.0324C19.2999 22.9532 21.7475 17.5125 20.6064 11.9048C19.9683 8.76957 18.3267 6.13485 16.1005 4.67605C14.5818 3.68134 12.9358 3.33403 11.3389 3.67346L11.34 3.67322Z"
      fill="url(#paint9_linear_11287_85115)"
    />
    <path
      style={{ mixBlendMode: "multiply" }}
      d="M16.4111 12.909C16.0324 12.7236 15.6305 12.6011 15.2071 12.5445C14.7824 12.4871 14.3775 12.4396 13.9938 12.403C13.7453 12.385 13.5117 12.3649 13.2949 12.346C13.077 12.3273 12.8838 12.2916 12.7145 12.2401C12.5465 12.1895 12.4069 12.1164 12.2965 12.0253C12.1861 11.9341 12.1149 11.8051 12.0826 11.6418C12.0339 11.4016 12.0967 11.2075 12.2706 11.0583C12.4448 10.9102 12.6588 10.8103 12.914 10.7596C13.1986 10.7027 13.4536 10.7347 13.6823 10.8539C13.9098 10.9734 14.0555 11.1917 14.1192 11.5079L16.8542 10.962C16.6676 10.0339 16.2906 9.3223 15.722 8.82751C15.1538 8.33385 14.4345 8.07551 13.564 8.05613L13.3472 6.97493L11.1417 7.41535L11.3551 8.48073C10.5474 8.82375 9.96513 9.32092 9.60579 9.97158C9.24782 10.6231 9.15823 11.3972 9.33789 12.2926C9.46328 12.9158 9.66844 13.4028 9.95248 13.7548C10.2368 14.1079 10.5601 14.3724 10.9228 14.5494C11.2846 14.7277 11.6727 14.8461 12.0872 14.9057C12.5015 14.9642 12.8951 15.0081 13.2684 15.0351C13.5169 15.0532 13.7505 15.0733 13.9673 15.0922C14.1852 15.1108 14.3807 15.1461 14.5532 15.1957C14.7259 15.2464 14.8699 15.3234 14.9816 15.4261C15.093 15.5276 15.1665 15.6621 15.1999 15.8251C15.2569 16.1096 15.1856 16.3528 14.987 16.5581C14.788 16.7623 14.5463 16.8928 14.2628 16.9495C13.9601 17.0103 13.6742 16.9719 13.4065 16.8302C13.1381 16.6911 12.9679 16.4354 12.8925 16.0639L10.0701 16.6272C10.2698 17.6222 10.6932 18.3854 11.3386 18.9135C11.9844 19.4438 12.7777 19.7112 13.7175 19.7171L13.9449 20.848L16.1356 20.4107L15.906 19.2637C16.733 18.9166 17.3456 18.4011 17.7445 17.7196C18.1434 17.0381 18.2429 16.1993 18.0432 15.2042C17.9156 14.5708 17.7077 14.0762 17.4165 13.7186C17.1265 13.3607 16.7924 13.0902 16.4126 12.9051L16.4111 12.909Z"
      fill="url(#paint10_radial_11287_85115)"
    />
    <path
      d="M13.0439 10.7913L14.0029 10.715C14.183 10.7004 14.3488 10.7349 14.5008 10.816C14.7048 10.9251 14.8363 11.1323 14.8951 11.4365L13.9361 11.5127C13.8773 11.2085 13.7458 11.0013 13.5418 10.8922C13.3895 10.81 13.2229 10.7769 13.0439 10.7913Z"
      fill="url(#paint11_linear_11287_85115)"
    />
    <path
      d="M14.809 20.4732L13.8489 20.5496L13.639 19.4622L14.598 19.386L14.809 20.4732Z"
      fill="url(#paint12_linear_11287_85115)"
    />
    <path
      d="M12.2131 7.56006L11.253 7.63652L13.2173 7.15164L14.1763 7.07542L12.2131 7.56006Z"
      fill="url(#paint13_linear_11287_85115)"
    />
    <path
      d="M12.4109 8.58506L11.4519 8.66128L11.253 7.63653L12.2131 7.56007L12.4109 8.58506Z"
      fill="url(#paint14_linear_11287_85115)"
    />
    <path
      d="M11.3227 16.4969L10.364 16.5743L12.8761 15.9528L13.8363 15.8764L11.3227 16.4969Z"
      fill="url(#paint15_linear_11287_85115)"
    />
    <path
      d="M14.5976 19.386L13.6386 19.4622C12.8 19.4822 12.0921 19.2439 11.5118 18.7492C10.9315 18.2546 10.5491 17.5288 10.3637 16.5732L11.3227 16.497C11.5083 17.4537 11.8905 18.1783 12.4708 18.673C13.0511 19.1676 13.7601 19.4057 14.5976 19.386Z"
      fill="url(#paint16_linear_11287_85115)"
    />
    <path
      d="M14.8763 16.726L13.9174 16.8022C13.979 16.7974 14.0419 16.7876 14.1048 16.7718C14.3668 16.7032 14.5763 16.5712 14.7481 16.3728C14.9237 16.17 14.9854 15.9324 14.932 15.6589C14.9023 15.5022 14.835 15.3747 14.7343 15.2791C14.6334 15.1824 14.5048 15.1117 14.3501 15.0677C14.1954 15.0238 14.0204 14.996 13.8262 14.983C13.631 14.9713 13.4224 14.9577 13.2014 14.9468C12.8681 14.9302 12.5174 14.8984 12.1472 14.853C11.7757 14.8067 11.4306 14.7016 11.1067 14.5401C10.7816 14.3787 10.4916 14.132 10.2358 13.7964C9.97857 13.4647 9.79316 12.9983 9.67646 12.3992C9.51014 11.5389 9.58459 10.7881 9.89894 10.1482C10.2147 9.50916 10.731 9.01301 11.449 8.65952L12.408 8.58329C11.6899 8.93679 11.1736 9.43293 10.8579 10.072C10.5436 10.7119 10.4689 11.4616 10.6354 12.323C10.7522 12.9221 10.9376 13.3885 11.1948 13.7202C11.4515 14.0544 11.7417 14.3023 12.0657 14.4638C12.3896 14.6254 12.7358 14.7302 13.1062 14.7768C13.4764 14.8222 13.8271 14.854 14.1604 14.8706C14.3814 14.8815 14.5898 14.8939 14.7852 14.9067C14.9792 14.9187 15.1544 14.9476 15.3091 14.9915C15.4638 15.0354 15.5912 15.1064 15.6933 15.2029C15.794 15.2985 15.8601 15.4262 15.891 15.5827C15.9433 15.8564 15.8826 16.0938 15.7071 16.2966C15.5355 16.4961 15.3246 16.6272 15.0637 16.6956C15.0009 16.7113 14.9382 16.7223 14.8763 16.726Z"
      fill="url(#paint17_linear_11287_85115)"
    />
    <path
      d="M16.9511 12.7292C16.6114 12.5604 16.2538 12.452 15.8746 12.4086C15.4954 12.3651 15.1344 12.3296 14.7901 12.3059C14.5689 12.2938 14.3608 12.2825 14.1665 12.2694C13.9725 12.2575 13.7996 12.2281 13.6491 12.1821C13.4992 12.1383 13.3739 12.0716 13.2753 11.9862C13.1768 11.9008 13.1118 11.7787 13.0821 11.622C13.0376 11.3904 13.092 11.2016 13.2471 11.0528C13.3962 10.9089 13.5805 10.8082 13.8179 10.746C14.0704 10.6828 14.2991 10.7075 14.5031 10.8166C14.7071 10.9256 14.8386 11.1328 14.8974 11.437L17.3334 10.8353C17.1601 9.9422 16.8189 9.26557 16.3078 8.80227C15.7971 8.34011 15.1537 8.11055 14.3782 8.11586L14.1773 7.07617L12.2141 7.56082L12.4119 8.58581C11.6939 8.93931 11.1776 9.43545 10.8619 10.0745C10.5475 10.7144 10.4728 11.4641 10.6394 12.3255C10.7561 12.9246 10.9415 13.391 11.1988 13.7227C11.4554 14.0569 11.7457 14.3048 12.0696 14.4664C12.3936 14.6279 12.7397 14.7328 13.1101 14.7793C13.4803 14.8247 13.8311 14.8565 14.1644 14.8731C14.3854 14.884 14.5937 14.8964 14.7891 14.9093C14.9831 14.9212 15.1583 14.9501 15.313 14.994C15.4678 15.038 15.5951 15.109 15.6972 15.2054C15.7979 15.301 15.8641 15.4287 15.895 15.5852C15.9472 15.8589 15.8866 16.0963 15.711 16.2991C15.5395 16.4986 15.3297 16.6294 15.0677 16.6981C14.7979 16.7637 14.5434 16.734 14.3033 16.6054C14.0625 16.4793 13.9093 16.2366 13.8404 15.879L11.3268 16.4995C11.5124 17.4562 11.8946 18.1808 12.4749 18.6755C13.0553 19.1701 13.7643 19.4082 14.6017 19.3885L14.8116 20.4759L16.7612 19.9942L16.548 18.8909C17.2827 18.5327 17.826 18.019 18.1767 17.3501C18.5284 16.6798 18.6098 15.8672 18.4242 14.9106C18.3062 14.2999 18.1162 13.8287 17.8541 13.4909C17.5934 13.154 17.2926 12.9012 16.9529 12.7324L16.9511 12.7292Z"
      fill="url(#paint18_linear_11287_85115)"
    />
    <path
      style={{ mixBlendMode: "color-dodge" }}
      opacity="0.64"
      d="M14.0636 7.10279L14.2637 8.13909C15.0395 8.13491 15.6826 8.36334 16.1934 8.8255C16.7041 9.28767 17.0456 9.96543 17.2189 10.8586L14.8953 11.4328C14.8953 11.4328 14.8958 11.4351 14.896 11.4362L17.332 10.8345C17.1587 9.9414 16.8175 9.26476 16.3065 8.80146C15.7957 8.3393 15.1523 8.10974 14.3768 8.11505L14.1759 7.07536L14.0636 7.10279Z"
      fill="url(#paint19_radial_11287_85115)"
    />
    <path
      style={{ mixBlendMode: "color-dodge" }}
      opacity="0.64"
      d="M14.1861 16.6268C14.4262 16.7554 14.6807 16.7852 14.9505 16.7196C14.955 16.7186 14.9584 16.7179 14.9629 16.7169C14.7295 16.7535 14.5089 16.7165 14.2994 16.6039C14.0586 16.4778 13.9054 16.2351 13.8365 15.8775L13.7241 15.905C13.7937 16.26 13.9467 16.5016 14.1863 16.628L14.1861 16.6268Z"
      fill="url(#paint20_radial_11287_85115)"
    />
    <path
      style={{ mixBlendMode: "color-dodge" }}
      opacity="0.64"
      d="M17.8513 13.4881C17.5905 13.1512 17.2897 12.8984 16.9501 12.7296C16.6104 12.5607 16.2528 12.4524 15.8736 12.4089C15.4944 12.3654 15.1334 12.3299 14.7891 12.3062C14.5679 12.2941 14.3598 12.2828 14.1655 12.2698C13.9715 12.2578 13.7986 12.2284 13.6481 12.1824C13.4982 12.1387 13.3729 12.0719 13.2743 11.9865C13.1758 11.9011 13.1109 11.779 13.0811 11.6223C13.0366 11.3907 13.091 11.2019 13.2462 11.0531C13.3935 10.9119 13.5744 10.812 13.8058 10.7498C13.7725 10.7545 13.7386 10.7617 13.704 10.7715C13.4667 10.8337 13.2824 10.9343 13.1333 11.0783C12.9782 11.2271 12.924 11.417 12.9682 11.6475C12.998 11.8042 13.063 11.9263 13.1615 12.0117C13.26 12.0971 13.3851 12.1627 13.5353 12.2076C13.6869 12.2533 13.8587 12.283 14.0527 12.2949C14.2467 12.3069 14.455 12.3193 14.6763 12.3314C15.0197 12.3564 15.3804 12.3908 15.7608 12.4341C16.1389 12.4778 16.4973 12.5847 16.8372 12.7547C17.1769 12.9236 17.4765 13.1766 17.7384 13.5132C18.0005 13.851 18.1908 14.3234 18.3085 14.9329C18.4941 15.8896 18.4113 16.7012 18.0611 17.3724C17.7103 18.0413 17.1673 18.5562 16.4323 18.9133L16.6455 20.0165L14.808 20.4697L14.8087 20.4731L16.7584 19.9913L16.5451 18.8881C17.2799 18.5299 17.8232 18.0162 18.1739 17.3473C18.5255 16.677 18.607 15.8644 18.4213 14.9077C18.3034 14.2971 18.1134 13.8258 17.8513 13.4881Z"
      fill="url(#paint21_radial_11287_85115)"
    />
    <path
      d="M15.1455 20.3897L14.938 19.3136C14.0995 19.3335 13.3916 19.0952 12.8113 18.6006C12.2309 18.1059 11.8485 17.3802 11.6632 16.4246L13.8396 15.8864C13.8396 15.8864 13.8381 15.8796 13.8372 15.8751L11.3236 16.4956C11.5093 17.4523 11.8914 18.1769 12.4717 18.6716C13.0521 19.1662 13.7611 19.4043 14.5985 19.3846L14.8084 20.472L15.1453 20.3886L15.1455 20.3897Z"
      fill="url(#paint22_linear_11287_85115)"
    />
    <path
      d="M14.8411 10.7447C14.6371 10.6357 14.4087 10.6121 14.1559 10.6741C14.1112 10.686 14.0705 10.7006 14.0296 10.714C14.1991 10.7051 14.3565 10.739 14.5016 10.8157C14.7057 10.9248 14.8372 11.132 14.8959 11.4362L15.2328 11.3527C15.173 11.0547 15.0433 10.8506 14.842 10.7434L14.8411 10.7447Z"
      fill="url(#paint23_linear_11287_85115)"
    />
    <path
      d="M12.0679 14.4644C12.3918 14.626 12.738 14.7308 13.1084 14.7773C13.4786 14.8227 13.8293 14.8545 14.1626 14.8711C14.3836 14.882 14.5919 14.8945 14.7873 14.9073C14.9814 14.9192 15.1565 14.9482 15.3113 14.9921C15.466 15.036 15.5934 15.107 15.6955 15.2035C15.7962 15.299 15.8623 15.4268 15.8932 15.5833C15.9455 15.8569 15.8848 16.0944 15.7092 16.2971C15.5661 16.4634 15.3961 16.5811 15.1922 16.6563C15.2622 16.6521 15.3333 16.6417 15.4052 16.6241C15.6672 16.5554 15.8767 16.4234 16.0485 16.225C16.2241 16.0222 16.2859 15.7846 16.2325 15.5112C16.2027 15.3544 16.1354 15.2269 16.0347 15.1313C15.9338 15.0346 15.8053 14.9639 15.6506 14.92C15.4958 14.876 15.3209 14.8482 15.1266 14.8352C14.9315 14.8235 14.7229 14.8099 14.5019 14.799C14.1686 14.7824 13.8178 14.7506 13.4477 14.7052C13.0761 14.6589 12.7311 14.5538 12.4071 14.3923C12.0821 14.231 11.792 13.9842 11.5363 13.6486C11.279 13.3169 11.0936 12.8506 10.9769 12.2515C10.8106 11.3911 10.885 10.6403 11.1994 10.0004C11.5151 9.36137 12.0314 8.86523 12.7494 8.51173L12.5516 7.48674L14.178 7.08552L14.1756 7.07421L12.2124 7.55886L12.4101 8.58385C11.6921 8.93735 11.1758 9.43349 10.8601 10.0725C10.5458 10.7124 10.4711 11.4621 10.6376 12.3236C10.7543 12.9227 10.9397 13.389 11.197 13.7207C11.4536 14.0549 11.7439 14.3028 12.0679 14.4644Z"
      fill="url(#paint24_linear_11287_85115)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11287_85115"
        x1="4.6733"
        y1="2.01942"
        x2="10.2391"
        y2="28.2045"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF196E" />
        <stop offset="0.08" stopColor="#274AE2" />
        <stop offset="0.25" stopColor="#FFB3C3" />
        <stop offset="0.36" stopColor="#EF196E" />
        <stop offset="0.46" stopColor="#F5FAD9" />
        <stop offset="0.6" stopColor="#EF196E" />
        <stop offset="0.75" stopColor="#274AE2" />
        <stop offset="0.88" stopColor="#EF196E" stopOpacity="0.35" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11287_85115"
        x1="7.09105"
        y1="5.39198"
        x2="19.5571"
        y2="22.9671"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.04" stopColor="#EF196E" />
        <stop offset="0.19" stopColor="#FFB3C3" />
        <stop offset="0.38" stopColor="#EF196E" />
        <stop offset="0.68" stopColor="#F5FAD9" />
        <stop offset="0.82" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11287_85115"
        x1="7.30163"
        y1="5.68865"
        x2="19.3323"
        y2="22.6496"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF196E" />
        <stop offset="0.18" stopColor="#FFB3C3" />
        <stop offset="0.32" stopColor="#F5FAD9" />
        <stop offset="0.62" stopColor="#FFB3C3" />
        <stop offset="0.81" stopColor="#EF196E" />
        <stop offset="0.96" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_11287_85115"
        x1="4.08289"
        y1="15.787"
        x2="21.8762"
        y2="12.0049"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF196E" />
        <stop offset="0.18" stopColor="#FFB3C3" />
        <stop offset="0.36" stopColor="#F5FAD9" />
        <stop offset="0.57" stopColor="#FFB3C3" />
        <stop offset="0.75" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_11287_85115"
        x1="5.61998"
        y1="2.60399"
        x2="10.6612"
        y2="26.321"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="0.05" stopColor="#F5FAD9" />
        <stop offset="0.1" stopColor="#EF196E" />
        <stop offset="0.25" stopColor="#FFB3C3" />
        <stop offset="0.4" stopColor="#EF196E" />
        <stop offset="0.54" stopColor="#FFB3C3" />
        <stop offset="0.64" stopColor="#FFB3C3" />
        <stop offset="0.75" stopColor="#274AE2" />
        <stop offset="0.92" stopColor="#EF196E" />
        <stop offset="0.99" stopColor="#274AE2" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_11287_85115"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.25346 14.7045) rotate(-12) scale(8.50284 8.49993)"
      >
        <stop offset="0.21" stopColor="#F5FAD9" />
        <stop offset="0.99" stopColor="#274AE2" />
      </radialGradient>
      <linearGradient
        id="paint6_linear_11287_85115"
        x1="3.03057"
        y1="-0.264233"
        x2="22.8701"
        y2="27.7067"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.31" stopColor="#FFB3C3" />
        <stop offset="0.99" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_11287_85115"
        x1="3.03017"
        y1="-0.264271"
        x2="22.8697"
        y2="27.7067"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.31" stopColor="#EF196E" />
        <stop offset="0.99" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_11287_85115"
        x1="7.55946"
        y1="6.18323"
        x2="19.1398"
        y2="22.5096"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.01" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_11287_85115"
        x1="3.0965"
        y1="-0.235829"
        x2="22.7667"
        y2="27.4946"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.31" stopColor="#FFB3C3" />
        <stop offset="0.99" stopColor="#EF196E" />
      </linearGradient>
      <radialGradient
        id="paint10_radial_11287_85115"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.7109 13.9614) rotate(-12) scale(6.03667 6.72036)"
      >
        <stop stopColor="#EF196E" />
        <stop offset="1" stopColor="#F5FAD9" />
      </radialGradient>
      <linearGradient
        id="paint11_linear_11287_85115"
        x1="13.5768"
        y1="10.4677"
        x2="14.4809"
        y2="11.7421"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.01" stopColor="#FFB3C3" />
        <stop offset="1" stopColor="#EF196E" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_11287_85115"
        x1="14.4779"
        y1="21.0174"
        x2="14.1337"
        y2="19.5981"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.01" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_11287_85115"
        x1="12.3773"
        y1="6.88116"
        x2="13.0755"
        y2="7.8649"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.01" stopColor="#FFB3C3" />
        <stop offset="1" stopColor="#EF196E" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_11287_85115"
        x1="11.4377"
        y1="7.55473"
        x2="12.2542"
        y2="8.70595"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.01" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_11287_85115"
        x1="11.706"
        y1="15.6698"
        x2="12.5209"
        y2="16.819"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.01" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_11287_85115"
        x1="11.0145"
        y1="16.2706"
        x2="13.6999"
        y2="20.0559"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.01" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_11287_85115"
        x1="10.2814"
        y1="9.72303"
        x2="15.2492"
        y2="16.7268"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.01" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_11287_85115"
        x1="8.17563"
        y1="5.00545"
        x2="20.4505"
        y2="22.3092"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.31" stopColor="#FFB3C3" />
        <stop offset="0.99" stopColor="#EF196E" />
      </linearGradient>
      <radialGradient
        id="paint19_radial_11287_85115"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.3245 8.58611) rotate(-12) scale(4.49307 4.49153)"
      >
        <stop stopColor="#274AE2" />
        <stop offset="1" stopColor="#F5FAD9" />
      </radialGradient>
      <radialGradient
        id="paint20_radial_11287_85115"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.6274 16.1785) rotate(-12) scale(1.11922 1.11884)"
      >
        <stop stopColor="#274AE2" />
        <stop offset="1" stopColor="#FFB3C3" />
      </radialGradient>
      <radialGradient
        id="paint21_radial_11287_85115"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.3067 14.3352) rotate(-12) scale(9.83365 9.83029)"
      >
        <stop stopColor="#274AE2" />
        <stop offset="1" stopColor="#FFB3C3" />
      </radialGradient>
      <linearGradient
        id="paint22_linear_11287_85115"
        x1="8.59554"
        y1="18.8539"
        x2="18.0214"
        y2="17.7372"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.31" stopColor="#EF196E" />
        <stop offset="0.99" stopColor="#274AE2" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_11287_85115"
        x1="7.76545"
        y1="11.8517"
        x2="17.1913"
        y2="10.735"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.31" stopColor="#FFB3C3" />
        <stop offset="0.99" stopColor="#EF196E" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_11287_85115"
        x1="7.86348"
        y1="12.6745"
        x2="17.2893"
        y2="11.5579"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.3" stopColor="#F5FAD9" />
        <stop offset="0.99" stopColor="#EF196E" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Coin;
